// useGalleryPagination.js

import { useMemo } from 'react';

import { VIEW_PAGINATION } from 'views/constants/viewPagination';
import useIncrementalPagination from 'views/hooks/useIncrementalPagination';

const isFolderItem = (item) => item?.__kind === 'FOLDER' || item?.type === 'FOLDER';

const useGalleryPagination = ({
    nodes,
    maxNodes,
    viewKey,
}) => {
    const filteredNodes = useMemo(() => {
        const baseNodes = Array.isArray(nodes) ? nodes.filter((node) => !isFolderItem(node)) : [];
        if (!Number.isFinite(maxNodes) || maxNodes <= 0) return baseNodes;
        return baseNodes.slice(0, maxNodes);
    }, [nodes, maxNodes]);

    // Reset only when browse context changes — not when live snapshots replace `nodes`.
    const paginationResetKey = `${String(viewKey || '')}|${maxNodes ?? ''}`;

    const {
        displayedItems: displayedNodes,
        hasMore,
        loadMoreRef,
    } = useIncrementalPagination({
        items: filteredNodes,
        initialCount: VIEW_PAGINATION.GALLERY.INITIAL,
        step: VIEW_PAGINATION.GALLERY.STEP,
        resetKey: paginationResetKey,
    });

    return {
        displayedNodes,
        hasMore,
        loadMoreRef,
    };
};

export default useGalleryPagination;
